<app-header></app-header>

<div class="editor-list">
  <div class="list-header">
    <h1>{{title}}</h1>
    <div class="list-controls">
      <label class="show-inactive">
        <app-toggle [checked]="showInactive" (valueChanged)="toggleShowInactive($event)"></app-toggle>
        Show Inactive
      </label>
      <button class="button" (click)="newDocument()">New {{editorType === 'report' ? 'Report' : 'View'}}</button>
    </div>
  </div>

  <table class="document-table" *ngIf="loaded">
    <thead>
      <tr>
        <th>Name</th>
        <th>Key</th>
        <th>Collection</th>
        <th *ngIf="editorType === 'report'">Type</th>
        <th *ngIf="editorType === 'report'">Category</th>
        <th *ngIf="editorType === 'view'">Importable</th>
        <th>Active</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let document of visibleDocuments" (click)="openDocument(document)" [class.inactive]="document.active === false">
        <td>{{document.name}}</td>
        <td>{{document.key}}</td>
        <td>{{document.collection}}</td>
        <td *ngIf="editorType === 'report'">{{document.type || 'standard'}}</td>
        <td *ngIf="editorType === 'report'">{{document.category}}</td>
        <td *ngIf="editorType === 'view'">{{document.importable ? 'Yes' : ''}}</td>
        <td>{{document.active === false ? 'No' : 'Yes'}}</td>
      </tr>
      <tr *ngIf="visibleDocuments.length === 0">
        <td colspan="6" class="empty-message">No documents found.</td>
      </tr>
    </tbody>
  </table>
</div>

<app-support *ngIf="supportActive"></app-support>
<app-settings *ngIf="settingsActive"></app-settings>
